/** Einstellungen – Frontend-Pfade (Unterseiten) */
export const SETTINGS_PATH_BUSINESS = '/settings/business';
export const SETTINGS_PATH_USERS = '/settings/users';
export const SETTINGS_PATH_ROLES = '/settings/roles';
export const SETTINGS_ROLE_NEW_ID = 'new';

export function roleSettingsPath(roleId?: string): string {
  if (!roleId) return SETTINGS_PATH_ROLES;
  return `${SETTINGS_PATH_ROLES}/${encodeURIComponent(roleId)}`;
}

export function roleIdFromSettingsPath(pathname: string): string | null {
  const prefix = `${SETTINGS_PATH_ROLES}/`;
  if (!pathname.startsWith(prefix)) return null;
  const suffix = pathname.slice(prefix.length);
  if (!suffix || suffix.includes('/')) return null;
  try {
    return decodeURIComponent(suffix);
  } catch {
    return null;
  }
}
/** Externe API (Schlüssel, Instanz-ID, Referenz) — unter „Integrationen“ in der Sidebar */
export const SETTINGS_PATH_USERS_API = '/settings/users/api';
/** Open Master Data + IDS / SHK-Connect */
export const SETTINGS_PATH_INTEGRATIONS = '/settings/integrations';
/** DATEV-Integration: Unterseite von „Integrationen“. */
export const SETTINGS_PATH_DATEV = '/settings/integrations/datev';
/** Detailseiten im Integrationskatalog. */
export const SETTINGS_PATH_INTEGRATION_OMD = '/settings/integrations/open-master-data';
export const SETTINGS_PATH_INTEGRATION_IDS = '/settings/integrations/ids';
export const SETTINGS_PATH_INTEGRATION_METAL = '/settings/integrations/metallnotierungen';
export const SETTINGS_PATH_INTEGRATION_DKV = '/settings/integrations/dkv';
export const SETTINGS_PATH_INTEGRATION_MEINSHK = '/settings/integrations/meinshk';
/** @deprecated Redirects to SETTINGS_PATH_INTEGRATIONS */
export const SETTINGS_PATH_OMD = '/settings/omd';
/** @deprecated Redirects to SETTINGS_PATH_INTEGRATIONS */
export const SETTINGS_PATH_OMD_GC = '/settings/omd-gc';
/** @deprecated Redirects to SETTINGS_PATH_INTEGRATIONS */
export const SETTINGS_PATH_IDS = '/settings/ids';
export const SETTINGS_PATH_PERSONAL = '/settings/personal';
export const SETTINGS_PATH_NOTIFICATIONS = '/settings/notifications';
export const SETTINGS_PATH_EMAIL_DISPATCH = '/settings/email-dispatch';
export const SETTINGS_PATH_DOCUMENT_TEXTS = '/settings/document-texts';
export const SETTINGS_PATH_INVOICE_TEMPLATE = '/settings/invoice-template';
export function invoiceTemplateSettingsPath(templateId?: string): string {
  if (!templateId) return SETTINGS_PATH_INVOICE_TEMPLATE;
  return `${SETTINGS_PATH_INVOICE_TEMPLATE}/${encodeURIComponent(templateId)}`;
}

export function invoiceTemplateIdFromSettingsPath(pathname: string): string | null {
  const prefix = `${SETTINGS_PATH_INVOICE_TEMPLATE}/`;
  if (!pathname.startsWith(prefix)) return null;
  const suffix = pathname.slice(prefix.length);
  if (!suffix || suffix.includes('/')) return null;
  try {
    return decodeURIComponent(suffix);
  } catch {
    return null;
  }
}
export const SETTINGS_PATH_LEAD_PIPELINE = '/settings/lead-pipeline';
/** @deprecated Redirects to lead-pipeline — categories live on that page. */
export const SETTINGS_PATH_LEAD_CATEGORIES = '/settings/lead-categories';
export const SETTINGS_PATH_ACTIVITY_TYPES = '/settings/activity-types';
export const SETTINGS_PATH_CHECKLISTS = '/settings/checklists';
export function checklistSettingsPath(checklistId?: string): string {
  if (!checklistId) return SETTINGS_PATH_CHECKLISTS;
  return `${SETTINGS_PATH_CHECKLISTS}/${encodeURIComponent(checklistId)}`;
}

export function checklistIdFromSettingsPath(pathname: string): string | null {
  const prefix = `${SETTINGS_PATH_CHECKLISTS}/`;
  if (!pathname.startsWith(prefix)) return null;
  const suffix = pathname.slice(prefix.length);
  if (!suffix || suffix.includes('/')) return null;
  try {
    return decodeURIComponent(suffix);
  } catch {
    return null;
  }
}
export const SETTINGS_PATH_PLANTAFEL = '/settings/plantafel';
export const SETTINGS_PATH_OFFERS_INVOICES = '/settings/offers-invoices';
/** @deprecated Redirects to SETTINGS_PATH_OFFERS_INVOICES */
export const SETTINGS_PATH_PAYMENT_CONDITIONS = '/settings/payment-conditions';
/** @deprecated Redirects to SETTINGS_PATH_OFFERS_INVOICES */
export const SETTINGS_PATH_LABOR_COST_SHARE = '/settings/labor-cost-share';
/** @deprecated Redirects to SETTINGS_PATH_OFFERS_INVOICES */
export const SETTINGS_PATH_LEGAL_ATTACHMENTS = '/settings/legal-attachments';
export const SETTINGS_PATH_INVOICE_FORWARDING = '/settings/invoice-forwarding';
export const SETTINGS_PATH_DOCUMENT_NUMBERING = '/settings/document-numbering';
export const SETTINGS_PATH_CUSTOMER_NUMBERING = '/settings/customer-numbering';
export const SETTINGS_PATH_PAYROLL_ADJUSTMENT_LOHNARTEN = '/settings/payroll-adjustment-lohnarten';
export const SETTINGS_PATH_EMPLOYEE_DOCUMENT_TYPES = '/settings/employee-document-types';
export const SETTINGS_PATH_RECYCLE_BIN = '/settings/recycle-bin';
export const SETTINGS_PATH_ASSISTANT = '/settings/assistant';

export const SETTINGS_PATHS = [
  SETTINGS_PATH_BUSINESS,
  SETTINGS_PATH_USERS,
  SETTINGS_PATH_ROLES,
  SETTINGS_PATH_USERS_API,
  SETTINGS_PATH_INTEGRATIONS,
  SETTINGS_PATH_DATEV,
  SETTINGS_PATH_INTEGRATION_OMD,
  SETTINGS_PATH_INTEGRATION_IDS,
  SETTINGS_PATH_INTEGRATION_METAL,
  SETTINGS_PATH_INTEGRATION_DKV,
  SETTINGS_PATH_INTEGRATION_MEINSHK,
  SETTINGS_PATH_OMD,
  SETTINGS_PATH_OMD_GC,
  SETTINGS_PATH_IDS,
  SETTINGS_PATH_PERSONAL,
  SETTINGS_PATH_NOTIFICATIONS,
  SETTINGS_PATH_EMAIL_DISPATCH,
  SETTINGS_PATH_DOCUMENT_TEXTS,
  SETTINGS_PATH_INVOICE_TEMPLATE,
  SETTINGS_PATH_LEAD_PIPELINE,
  SETTINGS_PATH_ACTIVITY_TYPES,
  SETTINGS_PATH_CHECKLISTS,
  SETTINGS_PATH_PLANTAFEL,
  SETTINGS_PATH_OFFERS_INVOICES,
  SETTINGS_PATH_PAYMENT_CONDITIONS,
  SETTINGS_PATH_LABOR_COST_SHARE,
  SETTINGS_PATH_LEGAL_ATTACHMENTS,
  SETTINGS_PATH_INVOICE_FORWARDING,
  SETTINGS_PATH_DOCUMENT_NUMBERING,
  SETTINGS_PATH_CUSTOMER_NUMBERING,
  SETTINGS_PATH_PAYROLL_ADJUSTMENT_LOHNARTEN,
  SETTINGS_PATH_EMPLOYEE_DOCUMENT_TYPES,
  SETTINGS_PATH_RECYCLE_BIN,
  SETTINGS_PATH_ASSISTANT,
] as const;

export type SettingsSubPath = (typeof SETTINGS_PATHS)[number];

export function isSettingsSubPath(pathname: string): boolean {
  return (
    (SETTINGS_PATHS as readonly string[]).includes(pathname) ||
    checklistIdFromSettingsPath(pathname) != null ||
    roleIdFromSettingsPath(pathname) != null ||
    invoiceTemplateIdFromSettingsPath(pathname) != null
  );
}
